import { addPermissionsToRoute } from '@/myq-core/';

const routes = {
  name: 'Payroll',
  icon: 'mdi-currency-usd',
  path: '/reports/mcd/payroll/',
  children: [
    {
      path: '/reports/mcd/people/employeeLookup',
      name: 'Employee Time Punches',
      meta: { id: 'reports-employeeLookup' },
      component: () => import('./employeeLookUp.vue'),
      ...addPermissionsToRoute(['storePeoplePunches']),
    },
    {
      path: '/reports/mcd/people/newHires',
      name: 'New Hires',
      meta: { id: 'reports-newHires' },
      component: () => import('./newHires/newHires.vue'),
      ...addPermissionsToRoute(['mcdEmployeeRoster']),
    },
    {
      path: '/reports/mcd/people/employeePayPeriod',
      name: 'Pay Period Activity',
      meta: { id: 'reports-payPeriodActivity' },
      component: () => import('./payPeriodActivity/payPeriodActivity.vue'),
      ...addPermissionsToRoute(['mcdEmployeePayPeriod']),
    },
    {
      path: '/reports/mcd/people/payrollPayCycleStatus',
      name: 'Pay Cycle Status',
      meta: { id: 'reports-payCycleStatus' },
      component: () => import('./payCycleStatus.vue'),
      ...addPermissionsToRoute(['mcdPayroll']),
    },
    {
      path: '/reports/mcd/people/payrollLedger',
      name: 'Payroll Ledger',
      meta: { id: 'reports-mcdPayroll' },
      component: () => import('./payrollLedger/payrollLedger.vue'),
      ...addPermissionsToRoute(['mcdPayroll']),
    },
    {
      path: '/reports/mcd/people/empPayDetails',
      name: 'Emp Pay Details',
      meta: { id: 'reports-empPayDetails' },
      component: () => import('./empPayDetails.vue'),
      ...addPermissionsToRoute(['empPayDetails']),
    },
    {
      path: '/reports/mcd/people/overtimeAudit',
      name: 'Overtime Audit',
      meta: { id: 'reports-mcdOvertimeAudit' },
      component: () => import('./overtimeAudit.vue'),
      ...addPermissionsToRoute(['mcdOvertimeAudit']),
    },
    {
      path: '/reports/mcd/people/employeeLookBack',
      name: 'Emp Hours Look Back',
      meta: { id: 'reports-empHoursLookBack' },
      component: () => import('./employeeLookBack.vue'),
      ...addPermissionsToRoute(['storePeoplePunches']),
    },
    {
      path: '/reports/mcd/people/studentPermitStatusCheck',
      name: 'Student Permit Status Check',
      meta: { id: 'reports-studentPermitStatusCheck' },
      component: () => import('./studentPermitCheck/studentPermitCheck.vue'),
      ...addPermissionsToRoute(['mcdEmployeeRoster']),
    },
  ]
};

export default routes;